import { RumLogger } from './RumLogger.js';
import { ServerLogger } from './ServerLogger.js';
import type { ElasticRumConfig, UserOptions } from './types.js';

export function createLogger(
  config: ElasticRumConfig,
  userOptions: UserOptions,
) {
  return typeof window === 'undefined'
    ? new ServerLogger()
    : new RumLogger(config, userOptions);
}

export type {
  ElasticApmInstance,
  ElasticRumConfig,
  ElasticTransaction,
  Logger as RumLogger,
  UserOptions,
} from './types.js';
